import "src/core";
import { BoundaryNames } from "src/shared/utils/sentry/BoundaryNames";
import { ViagogoAppEntrypoint } from "src/website-apps/shared/components/viagogo-app-entrypoint/viagogo-app-entrypoint";
import { App } from "./components/App";

export const FindRoot = () => (
  <ViagogoAppEntrypoint boundaryName={BoundaryNames.FIND}>
    <App />
  </ViagogoAppEntrypoint>
);
